import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-8 relative" }
const _hoisted_2 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_3 = { class: "mt-6 text-center" }
const _hoisted_4 = { class: "text-2xl font-semibold leading-6 text-gray-700" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-sm text-gray-400 mb-4" }
const _hoisted_7 = { class: "text-gray-500" }
const _hoisted_8 = { class: "mt-6 flex justify-around items-center flex-col" }
const _hoisted_9 = {
  type: "button",
  class: "px-8 py-2 text-base mt-3 flex flex-row justify-evenly items-center flex-wrap w-full"
}
const _hoisted_10 = { class: "text-gray-500" }
const _hoisted_11 = { class: "text-indigo-300" }
const _hoisted_12 = { class: "p-8 relative" }
const _hoisted_13 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_14 = { class: "mt-6 text-center" }
const _hoisted_15 = { class: "text-2xl font-semibold leading-6 text-gray-700" }
const _hoisted_16 = { class: "mt-4 text-center" }
const _hoisted_17 = { class: "text-sm text-gray-400 mb-4" }
const _hoisted_18 = { class: "text-gray-500" }
const _hoisted_19 = { class: "mt-6 flex justify-around items-center flex-col" }
const _hoisted_20 = {
  type: "button",
  class: "bg-indigo-300 rounded-full px-8 py-2 text-base shadow-lg text-white mx-2 flex flex-row justify-center items-center flex-wrap w-full"
}
const _hoisted_21 = { class: "text-gray-500" }
const _hoisted_22 = { class: "text-indigo-300" }
const _hoisted_23 = { class: "relative" }
const _hoisted_24 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_25 = { class: "flex flex-col items-center px-4 py-6" }
const _hoisted_26 = { class: "mt-6 font-semibold text-2xl text-gray-900" }
const _hoisted_27 = { class: "font-normal text-sm text-gray-600 text-center mt-2" }
const _hoisted_28 = { class: "font-normal text-sm text-red-600 text-center mt-5" }
const _hoisted_29 = { class: "p-8 relative" }
const _hoisted_30 = { class: "h-4" }
const _hoisted_31 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_32 = { class: "mt-5 text-center" }
const _hoisted_33 = { class: "text-lg font-semibold mb-1" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "text-sm text-gray-600 mb-8" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = { class: "mt-6 flex justify-around items-center flex-row" }
const _hoisted_38 = { class: "relative py-3 pt-4 px-1" }
const _hoisted_39 = { class: "flex flex-col bg-white gap-3 py-4 px-2" }
const _hoisted_40 = { class: "flex flex-col items-center gap-6 px-9" }
const _hoisted_41 = { class: "flex flex-col items-center text-center gap-2" }
const _hoisted_42 = { class: "font-semibold text-gray-900 text-lg" }
const _hoisted_43 = { class: "font-normal text-sm text-gray-600 w-[19rem]" }
const _hoisted_44 = { class: "flex flex-col gap-4 w-full" }


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminModals',
  props: {
    completeClassReviewModal: { type: Boolean },
    goToAssignModal: { type: Boolean },
    showLearnersBulkUploadProgressModal: { type: Boolean },
    showModal: { type: Boolean },
    showSendDetails: { type: Boolean },
    selectedGrade: {}
  },
  emits: ["update:completeClassReviewModal", "update:goToAssignModal", "update:showLearnersBulkUploadProgressModal", "update:showModal", "update:showSendDetails", "cancelSelection", "confirmSelection", "uploadInProgress", "confirmClassReview", "confirmRolloverComplete"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-xl',
      open: _ctx.completeClassReviewModal,
      onLocalModalOpen: _cache[1] || (_cache[1] = (val) =>_ctx.$emit('update:completeClassReviewModal', val))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-rollover-mail',
                title: 'rl rollover mail',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("admin_view.modals.complete_class_review.class_structure")), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("admin_view.modals.complete_class_review.final_step")), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("admin_view.modals.complete_class_review.soon_get_emails")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirmClassReview'))),
              type: "button",
              class: "bg-indigo-300 rounded-full px-8 py-2 text-base shadow-lg text-white mx-2 flex flex-row justify-center items-center flex-wrap w-full"
            }, _toDisplayString(_ctx.$t("admin_view.modals.complete_class_review.btn_confirm")), 1),
            _createVNode(_component_router_link, { to: "/main/internal" }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("admin_view.modals.complete_class_review.not_ready")), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("admin_view.modals.complete_class_review.come_back")), 1)
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-xl',
      open: _ctx.goToAssignModal,
      onLocalModalOpen: _cache[3] || (_cache[3] = (val) =>_ctx.$emit('update:goToAssignModal', val))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-group-of-people',
                title: 'rl group of people',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t("admin_view.modals.goto_assign.almost")), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("admin_view.modals.goto_assign.final_step")), 1),
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("admin_view.modals.goto_assign.number_students")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_router_link, { to: "/main/add-student" }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_20, _toDisplayString(_ctx.$t("admin_view.modals.goto_assign.assign")), 1)
              ]),
              _: 1
            }),
            _createElementVNode("button", {
              type: "button",
              class: "px-8 py-2 text-base mt-3 flex flex-row justify-evenly items-center flex-wrap w-full",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:goToAssignModal', false)))
            }, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("admin_view.modals.goto_assign.not_ready")), 1),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("admin_view.modals.goto_assign.come_back")), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg',
      open: _ctx.showLearnersBulkUploadProgressModal,
      onLocalModalOpen: _cache[6] || (_cache[6] = (val) =>_ctx.$emit('update:showLearnersBulkUploadProgressModal', val))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", {
                class: "absolute top-6 right-4 cursor-pointer",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('uploadInProgress')))
              }, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-large-close',
                  title: 'rl large close',
                  "aria-hidden": "true"
                })
              ]),
              _createElementVNode("h1", _hoisted_26, _toDisplayString(_ctx.$t("admin_screens.modals.almost")), 1),
              _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("admin_screens.modals.check_email_text")), 1),
              _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t("admin_screens.modals.note_text")), 1),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('uploadInProgress'))),
                class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 mt-8 w-full"
              }, _toDisplayString(_ctx.$t("archive_flow.done")), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg',
      open: _ctx.showModal,
      onLocalModalOpen: _cache[10] || (_cache[10] = (val) => _ctx.$emit('update:showModal', val))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('cancelSelection', _ctx.selectedGrade ?? ''))),
              class: "absolute top-4 right-4"
            }, [
              _createElementVNode("span", _hoisted_30, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-large-close',
                  title: 'rl large close',
                  "aria-hidden": "true"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-two-people',
                title: 'rl two people',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.$t("admin_screens.modals.add_new_grade_header")) + "! ", 1)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("p", _hoisted_35, [
                _createTextVNode(_toDisplayString(_ctx.$t("admin_screens.modals.are_you_sure")) + " [grade] ", 1),
                _hoisted_36,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.modals.to_the_program")) + "? ", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("button", {
              type: "button",
              class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('cancelSelection', _ctx.selectedGrade ?? '')))
            }, _toDisplayString(_ctx.$t("admin_screens.modals.cancel")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('confirmSelection', _ctx.selectedGrade ?? '')))
            }, _toDisplayString(_ctx.$t("admin_screens.modals.im_sure")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: false,
      widthClass: 'max-w-lg',
      open: _ctx.showSendDetails,
      onLocalModalOpen: _cache[12] || (_cache[12] = (val) =>_ctx.$emit('update:showSendDetails', val))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", null, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-green-tick',
                  title: 'rl green tick',
                  "aria-hidden": "true"
                })
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("h1", _hoisted_42, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.success")), 1),
                _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.success_message")), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("button", {
                  class: "rounded-lg py-2 px-6 text-white w-full font-semibold bg-blue-600",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('update:showSendDetails', false)))
                }, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.btn_view")), 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})